import { useRef } from 'react'

/**
 * Returns `value` as of the last render where `ready` was true (undefined before the first one).
 * Lets a transient "loading" flip keep the previously resolved value instead of unmounting or
 * switching whatever depends on it.
 */
export function useLatchedValue<T>(value: T, ready: boolean): T | undefined {
  const latched = useRef<{ value: T } | null>(null)
  if (ready) latched.current = { value }
  return latched.current?.value
}
